export default __webpack_public_path__ + "static/media/Qunoot.faf3e95c.mp3";